import {
    RESET_STATE
} from "../constant-types"
import { defaultLoadOptionAction, defaultSetOptionMutation } from "../default-method"

const getDefaultState = () => {
    return {
        options: [],
        option_url: 'contact-class/option'
    }
}
export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ...defaultSetOptionMutation
    },
    // can async
    actions: {
        ...defaultLoadOptionAction
    },
    // call variable with custom display
    getters: {

    },
    // modules
    modules: {

    }
})
